import script from "./StatChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatChart.vue?vue&type=script&setup=true&lang=ts"

import "./StatChart.vue?vue&type=style&index=0&id=2196c488&scoped=true&lang=scss"

import exportComponent from "/home/dorian/programy/vue-draft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2196c488"]])

export default __exports__